import PropTypes from 'prop-types'
import { Button } from 'components/buttons'
import Image from 'components/image'
import classnames from 'classnames'
import css from './call-to-action-box.scss'

const CallToActionBox = ({
  img,
  title,
  body,
  buttonText,
  buttonVariant = 'primary',
  href,
}) => (
  <a
    href={href}
    className={classnames(css.callToActionBox, 'text-center pvxl phl')}
  >
    <Image src={img} height="65" role="none" />
    <div className="h5 text-bold mbn mtl">{title}</div>
    <div className="h6 mts mbl">{body}</div>
    <Button variant={buttonVariant} className="phxl">
      {buttonText}
    </Button>
  </a>
)

CallToActionBox.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonVariant: PropTypes.string,
  href: PropTypes.string.isRequired,
}

export default CallToActionBox
